(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.directive('entityTranslationTable', ['ItemTableService', EntityTranslationTableFn]);

    function EntityTranslationTableFn(ItemTableService) {

        var directive = {
            link: link,
            restrict: 'E',
            replace: true,
            templateUrl: '/app/global/templates/rf-global-entity-translation-table.template.html',
            scope: {
                translations: '=',
                languages: '=',
                prototype: '=',
                requiredFields: '=?',
                editInSummernote: '=?' // if true, opens a summernote modal for editing when user clicks in input field
            }
        };
        return directive;

        function link(scope, element, attrs) {
            // table status -> to proof if table is in edit mode ?
            scope.status = false;
            // only the active ones
            scope.filterShowAll = false;

            // functions
            scope.add = add;

            activate();


            // activation work
            function activate() {

                // init translation list
                ItemTableService.init(scope.translations, scope.languages, scope.prototype, scope.requiredFields);

                // link to variable for show
                scope.translations = ItemTableService.list();

                // status of table
                scope.status = ItemTableService.data;

                // if new -> immediate add new item
                if (scope.translations.length <= 0) {
                    add();
                } //if

            } // activate

            // add new row to table
            function add() {
                ItemTableService.add();
                scope.languages = ItemTableService.languageList();
            }

        }
    }

})();